var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 3.25C23.7836 3.25 24.7011 3.25 25.5185 3.26624C25.3055 3.75957 25.1875 4.30351 25.1875 4.875V5.6875H24.375C22.1313 5.6875 20.3125 7.50634 20.3125 9.75C20.3125 11.9937 22.1313 13.8125 24.375 13.8125H25.1875V14.625C25.1875 16.8687 27.0063 18.6875 29.25 18.6875C30.5789 18.6875 31.7588 18.0494 32.5 17.0629V26C32.5 30.5962 32.5 32.8943 31.0721 34.3221C29.6443 35.75 27.3462 35.75 22.75 35.75H16.25C11.6538 35.75 9.35571 35.75 7.92785 34.3221C6.5 32.8943 6.5 30.5962 6.5 26V13C6.5 8.40381 6.5 6.10571 7.92785 4.67785C9.35571 3.25 11.6538 3.25 16.25 3.25H22.75ZM13 17.875C12.1025 17.875 11.375 18.6025 11.375 19.5C11.375 20.3975 12.1025 21.125 13 21.125H19.5C20.3975 21.125 21.125 20.3975 21.125 19.5C21.125 18.6025 20.3975 17.875 19.5 17.875H13ZM13 22.75C12.1025 22.75 11.375 23.4775 11.375 24.375C11.375 25.2725 12.1025 26 13 26H22.75C23.6475 26 24.375 25.2725 24.375 24.375C24.375 23.4775 23.6475 22.75 22.75 22.75H13ZM13 27.625C12.1025 27.625 11.375 28.3525 11.375 29.25C11.375 30.1475 12.1025 30.875 13 30.875H19.5C20.3975 30.875 21.125 30.1475 21.125 29.25C21.125 28.3525 20.3975 27.625 19.5 27.625H13Z",
    fill: "#0096FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 4.875L29.25 14.625",
    stroke: "#0096FF",
    strokeWidth: 3.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.125 9.75L24.375 9.75",
    stroke: "#0096FF",
    strokeWidth: 3.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.e0c31ea4146c93d86e9a59b9a2880712.svg";
export { ForwardRef as ReactComponent };